export default {"src":"/_next/static/media/features-rectangle.2acb968c.svg","height":405,"width":1002,"blurWidth":0,"blurHeight":0};